var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__UsageSideList"},[_c('UsageTypeSelector',{attrs:{"active":_vm.active}}),_c('router-view',{attrs:{"name":"side_list"},on:{"click":_vm.onClickItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }